import { Component, OnInit } from '@angular/core';
import { Role } from '../../core/models/role.model';
import { RoleService } from '../../core/services/role.service';
import { LoadingService } from '../../core/services/loading.service';
import { SETTINGS } from '../../core/config/common.settings';

@Component({
  selector: 'app-roles',
  templateUrl: './roles.component.html',
  styleUrls: ['./roles.component.scss'],
})
export class RolesComponent implements OnInit {
  allRoles: Role[] = [];

  constructor(
    private roleService: RoleService,
    private loading: LoadingService
  ) {}

  ngOnInit(): void {
    this.loading.start();
    Promise.all([this.loadAllRoles()]).then(() => this.loading.stop());
  }
  async loadAllRoles(): Promise<any> {
    try {
      this.allRoles = await this.roleService.getAllRoles();
    } catch (e) {
      this.allRoles = [];
    }
  }

  protected readonly SETTINGS = SETTINGS;
}
